module.exports = __webpack_public_path__ + "static/cely_rose_grossesse-c4dde14d6f7c1590cb499f7abaaf2c11.jpg";